module.exports = __webpack_public_path__ + "static/media/chevron-down.f016a4ba.svg";